var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgDrop = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 256,
  height: 158,
  fill: "#fff",
  stroke: "#000",
  strokeOpacity: 0.2
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillOpacity: 0.2,
  strokeDasharray: "4 4",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M1 13C1 6.373 6.373 1 13 1h230c6.627 0 12 5.373 12 12v132c0 6.627-5.373 12-12 12H13c-6.627 0-12-5.373-12-12V13Z"
})));
export { SvgDrop as ReactComponent };